// @flow

import { i18n } from 'shared/utils';

export default () => [
  {
    label: i18n.t('RMA # · Low to High'),
    value: { field: 'RETURN_NUMBER', direction: 'ASC' },
  },
  {
    label: i18n.t('RMA # · High to Low'),
    value: { field: 'RETURN_NUMBER', direction: 'DESC' },
  },
  {
    label: i18n.t('Customer · A to Z'),
    value: { field: 'CUSTOMER', direction: 'ASC' },
  },
  {
    label: i18n.t('Customer · Z to A'),
    value: { field: 'CUSTOMER', direction: 'DESC' },
  },
  {
    label: i18n.t('Order # · Low to High'),
    value: { field: 'ORDER_NUMBER', direction: 'ASC' },
  },
  {
    label: i18n.t('Order # · High to Low'),
    value: { field: 'ORDER_NUMBER', direction: 'DESC' },
  },
  {
    label: i18n.t('Status · A to Z'),
    value: { field: 'STATUS', direction: 'ASC' },
  },
  {
    label: i18n.t('Status · Z to A'),
    value: { field: 'STATUS', direction: 'DESC' },
  },
  {
    label: i18n.t('Return Type · A to Z'),
    value: { field: 'RETURN_TYPE', direction: 'ASC' },
  },
  {
    label: i18n.t('Return Type · Z to A'),
    value: { field: 'RETURN_TYPE', direction: 'DESC' },
  },
  {
    label: i18n.t('Reason · A to Z'),
    value: { field: 'REASON', direction: 'ASC' },
  },
  {
    label: i18n.t('Reason · Z to A'),
    value: { field: 'REASON', direction: 'DESC' },
  },
  {
    label: i18n.t('Last Updated - Oldest'),
    value: { field: 'UPDATED_AT', direction: 'ASC' },
  },
  {
    label: i18n.t('Last Updated - Most Recent'),
    value: { field: 'UPDATED_AT', direction: 'DESC' },
  },
  {
    label: i18n.t('Date Created - Oldest'),
    value: { field: 'CREATED_AT', direction: 'ASC' },
  },
  {
    label: i18n.t('Date Created - Most Recent'),
    value: { field: 'CREATED_AT', direction: 'DESC' },
  },
];
